const LOCAL_DEV_APP_MODES = new Set(["dev", "local", "development"]);

function normalizeAppMode(value: string | undefined): string {
  return (value ?? "").trim().toLowerCase();
}

/**
 * True when VITE_APP_MODE is dev, local, or development.
 * Falls back to Vite's DEV flag when VITE_APP_MODE is unset.
 */
export function isLocalDevAppMode(): boolean {
  const configured = normalizeAppMode(import.meta.env.VITE_APP_MODE);
  if (configured) {
    return LOCAL_DEV_APP_MODES.has(configured);
  }
  return import.meta.env.DEV;
}
